import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReactRouterPropTypes from 'react-router-prop-types';
import HttpErrorMessages from "./HttpErrorMessages/HttpErrorMessages.jsx";
import MainPageLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout';
import PropTypes from 'prop-types';

class ErrorPageHandler extends Component {
  static propTypes = {
    match: ReactRouterPropTypes.match,
    erroCode: PropTypes.string
  };

  render() {
    return (
      <MainPageLayout>
        <HttpErrorMessages httpCode={this.props.match?.params?.errorCode} />
      </MainPageLayout>
    );
  }
}

export default withRouter(ErrorPageHandler);
